<template>
  <div class="d-flex align-center text-primary" data-testid="users-say-section">
    <div class="d-flex align-center" v-if="safeVoteCount" data-testid="safe-vote-section">
      <v-icon icon="$usersSaySafe" size="24" class="mr-2" data-testid="safe-vote-icon" />
      <span data-testid="safe-vote-count">{{ safeVoteCount }}</span>
      <span class="ml-1 text-lowercase" data-testid="safe-vote-label">{{
        $t("general.tooltips.usersSaySafe")
      }}</span>
    </div>
    <div
      class="d-flex align-center text-primary"
      v-if="suspiciousVoteCount"
      data-testid="suspicious-vote-section"
    >
      <v-icon icon="$usersSayPhishing" size="24" class="mr-2" data-testid="suspicious-vote-icon" />
      <span data-testid="suspicious-vote-count">{{ suspiciousVoteCount }}</span>
      <span class="ml-1 text-lowercase" data-testid="suspicious-vote-label">{{
        $t("general.tooltips.usersSayPhishing")
      }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  suspiciousVoteCount?: number;
  safeVoteCount?: number;
}>();
</script>
